module.exports = __webpack_public_path__ + "static/media/login-header.82dcd06e.png";